import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { sendMessageStore } from '../../../modules/unityLayout/sendMessage.store';
import { ModalcontainerView } from '../modalcontainerView/modalcontainer.view';
import { ModalContainerProps } from '../modalcontainer.type';

export const ModalcontainerController: React.FC<ModalContainerProps> = observer(
  ({
    className = '',
    backBtn,
    children,
    closePopup,
    headerText,
    backBtnInfo,
    minimized,
    canClose,
    classNameBody,
    positions,
    dynamicWidth,
    popupIconUri
  }): JSX.Element => {
    useEffect(() => {
      if (sendMessageStore.sendMessage) {
        sendMessageStore.lockKeyboardInput();
        return () => sendMessageStore.unLockKeyboardInput();
      }
    }, []);
    return (
      <ModalcontainerView
        className={className}
        positions={positions}
        backBtn={backBtn}
        closePopup={closePopup}
        headerText={headerText}
        backBtnInfo={backBtnInfo}
        minimized={minimized}
        canClose={canClose}
        classNameBody={classNameBody}
        dynamicWidth={dynamicWidth}
        popupIconUri={popupIconUri}
      >
        {children}
      </ModalcontainerView>
    );
  },
);
